import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconAlignedProps, IconRender } from '../types.ts';

const Chevron = React.forwardRef<SVGSVGElement | null, IconAlignedProps>(function Chevron({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.8805 7.79289L19.6484 14.5865C19.8428 14.7816 19.8428 15.0971 19.6484 15.2922L19.2976 15.6444C19.1022 15.8406 18.7845 15.8406 18.5891 15.6444L12 9.03033L5.41088 15.6444C5.21546 15.8406 4.89785 15.8406 4.70243 15.6444L4.35155 15.2922C4.15718 15.0971 4.15718 14.7816 4.35155 14.5865L11.1195 7.79289C11.6058 7.30474 12.3942 7.30474 12.8805 7.79289Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'chevron-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Chevron;
